module.exports = __webpack_public_path__ + "img/Banner_Career.a2eb9aa1.png";